export enum DriverPaymentTypeEnum {
  money = 'Dinheiro',
  bank_check = 'Cheque',
  bank_deposit = 'Depósito',
}
